// Wir hängen das translations-Objekt global an window
window.rebuyTranslations = {
    de: {
        announcement_bar: {
            bars: [{messages: ["Gratis Versand ab 50€!", "Sichere dir heute exklusive Deals!"]},{messages: ["Fast geschafft!", "Dein Rabatt wurde freigeschaltet!"]}]
        },
        smart_cart: {
            bmsm_discount_message: "Kaufe {{quantity}} und spare {{discount}}",
            bmsm_discount_success: "Mehr kaufen, mehr sparen!",
            cart_title: "Dein Warenkorb",
            checking_out_label: "Sicher zur Kasse...",
            checkout_label: "Jetzt bestellen",
            continue_shopping_label: "Weiter einkaufen",
            discount_button_label: "Einlösen",
            discount_code_label: "Rabattcode oder Geschenkkarte",
            discount_invalid_message: "Der Code ist ungültig",
            discount_label: "Rabattcode oder Geschenkkarte",
            empty_cart_markup: "<h4 class=\"ql-align-center\">Dein Warenkorb ist noch leer!</h4><p class=\"ql-align-center\">Füge jetzt deine Lieblingsartikel hinzu.</p><p class=\"ql-align-center\"><a href=\"/collections/all\">Jetzt stöbern</a></p>",
            gift_title: "Deine Gratis-Geschenke",
            login_title: "Anmelden",
            notes_label: "Bestellhinweis hinzufügen",
            notes_placeholder: "Besondere Wünsche zu deiner Bestellung? Schreib es uns hier...",
            notes_remaining_characters: "",
            select_gift: "Wäle dein Geschenk",
            subtotal_plural_text: "Zwischensumme {{item_count}} Artikel)",
            subtotal_singular_text: "Zwischensumme {{item_count}} Artikel)",
            terms_and_conditions_label: "Ich akzeptiere die Allgemeinen Geschäftsbedingungen",
            view_cart_label: "Warenkorb anzeigen",
            view_cart_working_label: "Warenkorb wird geladen...",
        },
        cart_switch_to_subscription:{
            downgrading_label: "Wird umgestellt...",
            onetime_option_group_label: "Einmaliger Kauf",
            onetime_option_label: "Einmaliger Kauf",
            subscription_option_group_label: "Abonnieren & {{subscription_discount}}% sparen",
            upgrade_to_subscription_label: "Zum Abo wechseln & {{subscription_discount}}% sparen",
            upgrade_to_subscription_without_discount_label: "Zum Abo wechseln",
            upgrading_label: "Wird auf Abo umgestellt...",
        },
        tier_progress_bar:{
            decorative_amount_remaining_label_text: 'Du bist nur noch {{remaining_amount}} von etwas Großartigem entfernt!',
            decorative_amount_reached_label_text: 'Du hast ein Extra freigeschaltet!',
            discount_amount_remaining_label_text: "Du bist noch {{remaining_amount}} von {{discount_amount}} Rabatt auf deine Bestellung entfernt!",
            discount_amount_reached_label_text: "Du hast {{discount_amount}} Rabatt auf deine Bestellung freigeschaltet!",   
            free_shipping: "KOSTENLOSER VERSAND",
            free_shipping_reached: "Glückwunsch! Du hast <b>KOSTENLOSEN VERSAND</b> freigeschaltet!",
            free_shipping_remaining: "Du bist nur noch {{remaining_amount}} von <b>KOSTENLOSEM VERSAND</b> entfernt!",
            product_amount_reached_label_text: "Du hast ein kostenloses {{product_title}} freigeschaltet!",
            product_amount_remaining_label_text: "Du bist nur noch {{remaining_amount}} von einem kostenlosen {{product_title}} entfernt!",
        },
        widget: {
            add_to_cart: "Hinzufügen",
            added_to_cart: "Hinzugefügt",
            adding_to_cart: "Wird hinzugefügt...",
            cart_switch_to_onetime: "Zu Einmal-Kauf wechseln",
            cart_switch_to_subscription: "Zu Abo wechseln",
            cart_switch_to_subscription_footer: "",
            continue: "Weiter",
            decline: "Nein, danke",
            delivery_frequency_label: "Lieferintervall:",
            description: "Möchtest du das hinzufügen?",
            learn_more_label: "Mehr erfahren",
            remove_body: "Möchtest du diesen Artikel wirklich entfernen?",
            remove_confirm: "Ja, entfernen",
            remove_deny: "Abbrechen",
            remove_from_cart: "Entfernen",
            remove_title: "Artikel entfernen",
            removed_from_cart: "Entfernt",
            removing_from_cart: "Wird entfernt...",
            sold_out_label: "Ausverkauft",
            super_title: "Für dich",
            thank_you_button: "Schließen",
            thank_you_description: "Vielen Dank für deine Auswahl!",
            thank_you_title: "Erfolgreich hinzugefügt",
            timer_title: "Dein Angebot endet in: ",
            title: "Das könnte dir auch gefallen",
            total_price_label: "Gesamtpreis: ",
            upgrade_to_subscription: "Auf Abo upgraden",
            variant_option: "Option",
            variant_options: "Optionen",
            add_to_bundle: "Zum Bundle hinzufügen",
            bundle_container_title: "Mein Bundle",
            excluded_bundle_discount_text: "Rabatte über den Fortschrittsbalken gelten nur für einmalige Käufe, nicht für Abonnements.",
            fixed_tier_discount: "auf die Gesamtsumme angewendet",
            hide_bundle: "Bundle ausblenden",
            save_label: "Sparen",
            select_product: "Produkt auswählen",
            sold_out: "Ausverkauft",
            switch_to_subscription_description: "Kostenloser Versand. Jederzeit flexibel kündbar.",
            switch_to_subscription_interval_label: "Lieferung alle",
            switch_to_subscription_title: "Abonnieren & sparen",
            view_bundle: "Mein Bundle ansehen",
        }
    }
};

// Die Rebuy-Logik wird erst definiert
window.updateSmartCartLanguage = () => {
    const locale = window.Shopify?.locale;
    if (!locale || !window.Rebuy?.SmartCart?.settings) return;

    const translation = window.rebuyTranslations[locale]?.smart_cart;
    const subscriptionTranslations = window.rebuyTranslations[locale]?.cart_switch_to_subscription;
    const tierProgressBarTranslations = window.rebuyTranslations[locale]?.tier_progress_bar;
    const components = window.Rebuy.SmartCart.settings.components;
    const buyMoreSaveMore = window.Rebuy.SmartCart.settings.buy_more_save_more;
    const emptyCart = window.Rebuy.SmartCart.settings.empty_cart_markup;
    const switchToSubscription = window.Rebuy.SmartCart.settings.switch_to_subscription;
    
    // Sicherstellen, dass ShopifyStorefrontHelper existiert
    if (typeof ShopifyStorefrontHelper !== 'undefined') {
        const storefrontHelper = new ShopifyStorefrontHelper();
    }

    if (translation && components) {
        components.forEach((component) => {
            switch (component.type) {
                case 'checkout': {
                    if (!component.settings.language) component.settings.language = {};
                    Object.assign(component.settings.language, {
                        checkout_label: translation.checkout_label,
                        view_cart_label: translation.view_cart_label,
                        checking_out_label: translation.checking_out_label,
                        view_cart_working_label: translation.view_cart_working_label,
                        continue_shopping_label: translation.continue_shopping_label,
                        terms_and_conditions_label: translation.terms_and_conditions_label
                    });
                    break;
                }
                case 'cart_subtotal': {
                    Object.assign(component.settings, {
                        subtotal_plural_text: translation.subtotal_plural_text,
                        subtotal_singular_text: translation.subtotal_singular_text
                    });
                    break;
                }
                case 'tiered_progress_bar': {
                    if (tierProgressBarTranslations && component.settings.bars) {
                        const progressBarTranslation = {
                            free_shipping_reached: tierProgressBarTranslations.free_shipping_reached,
                            free_shipping_remaining: tierProgressBarTranslations.free_shipping_remaining,
                            product_amount_reached_label_text: tierProgressBarTranslations.product_amount_reached_label_text,
                            product_amount_remaining_label_text: tierProgressBarTranslations.product_amount_remaining_label_text,
                            decorative_amount_reached_label_text: tierProgressBarTranslations.decorative_amount_reached_label_text,
                            decorative_amount_remaining_label_text: tierProgressBarTranslations.decorative_amount_remaining_label_text,
                            discount_amount_remaining_label_text : tierProgressBarTranslations.discount_amount_remaining_label_text,
                            discount_amount_reached_label_text : tierProgressBarTranslations.discount_amount_reached_label_text,
                        };
                        component.settings.bars.forEach((bar) => {
                            if (!bar.language) bar.language = {};
                            Object.assign(bar.language, progressBarTranslation);
                            
                            bar.tiers.forEach((tier, index) => {
                                if (tier.type !== 'shipping') {
                                    Object.assign(tier, progressBarTranslation);
                                }
                                if (tier.type === 'shipping') {
                                    const labels = document.querySelectorAll('.rebuy-cart__progress-step-label');
                                    if (labels[index]) labels[index].innerText = tierProgressBarTranslations.free_shipping;
                                }
                            });
                        });
                    }
                    break;
                }
                case 'title_bar': {
                    component.settings.title = translation.cart_title;
                    break;
                }
                case 'login': {
                    if (!component.settings.language) component.settings.language = {};
                    component.settings.language.title = translation.login_title;
                    break;
                }
                case 'discount_code': {
                    if (!component.settings.language) component.settings.language = {};
                    Object.assign(component.settings.language, {
                        discount_code_label: translation.discount_code_label,
                        discount_button_label: translation.discount_button_label,
                        discount_invalid_message: translation.discount_invalid_message
                    });
                    break;
                }
                case 'notes': {
                    if (!component.settings.language) component.settings.language = {};
                    Object.assign(component.settings.language, {
                        notes_label: translation.notes_label,
                        notes_placeholder: translation.notes_placeholder,
                        notes_remaining_characters: translation.notes_remaining_characters
                    });
                    break;
                }
            }
        });

        if (buyMoreSaveMore && buyMoreSaveMore.language) {
            Object.assign(buyMoreSaveMore.language, {
                bmsm_discount_message: translation.bmsm_discount_message,
                bmsm_discount_success: translation.bmsm_discount_success
            });
        }
      
        if (emptyCart) {
            window.Rebuy.SmartCart.settings.empty_cart_markup = translation.empty_cart_markup;
        }

        if (switchToSubscription && switchToSubscription.language) {
            Object.assign(switchToSubscription.language, {
                downgrading_label: subscriptionTranslations.downgrading_label,
                onetime_option_group_label: subscriptionTranslations.onetime_option_group_label,
                onetime_option_label: subscriptionTranslations.onetime_option_label,
                subscription_option_group_label: subscriptionTranslations.subscription_option_group_label,
                upgrade_to_subscription_label: subscriptionTranslations.upgrade_to_subscription_label,
                upgrade_to_subscription_without_discount_label: subscriptionTranslations.upgrade_to_subscription_without_discount_label,
                upgrading_label: subscriptionTranslations.upgrading_label,
            });
        }
    }
};

window.updateWidgetLanguage = (widget) => {
    const locale = window.Shopify?.locale;
    if (!locale || !widget?.data?.settings?.language) return;
    const globalTranslation = window.rebuyTranslations[locale]?.widget;
    if (globalTranslation) {
        Object.assign(widget.data.settings.language, globalTranslation);
        widget.compileConfig();
    }
};

// Event Listeners abfangen
document.addEventListener('rebuy:smartcart.ready', () => {
    window.updateSmartCartLanguage();
});

document.addEventListener('rebuy.ready', (event) => {
    const widget = event.detail.widget;
    window.updateWidgetLanguage(widget);
});

document.addEventListener('rebuy:cart.change', () => {
    setTimeout(() => {
        window.updateSmartCartLanguage();
    }, 50);
});